import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import useTranslation from "../hooks/traslation";

interface SkillDetailsModalProps {
  name: string;
  open: boolean;
  selectedId: string;
  onClose: () => void;
  nameAr: string;
}

export default function SkillDetails({
  open,
  name,
  selectedId,
  onClose,
  nameAr,
}: SkillDetailsModalProps) {
  const isViewMode = Boolean(selectedId);
  const translate = useTranslation();

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Skill Details</h2>
            <div className="btn-close" onClick={onClose}>
              <CloseIcon />
            </div>
          </div>

          <form className="form" action="">
            <div className="control_group">
              <label>Skill Name {translate?.main?.english || "English"}</label>
              <TextField
                placeholder="Skill Name"
                fullWidth
                value={name}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>
            <div className="control_group">
              <label>Skill Name {translate?.main?.arabic || "Arabic"}</label>
              <TextField
                placeholder="Skill Name Arabic"
                fullWidth
                value={nameAr}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
